/**
 * @author: yanhoup
 * @description: 操作栏
 */

import React, { ReactNode, useEffect, useState } from 'react';
import { Box } from '@fpxfd/next';
import styles from './index.module.scss';

export interface ActionAreaProps {
  rightSection?: ReactNode;
  leftSection?: ReactNode;
  hasSettingBtn?: boolean; // 是否显示配置列按钮
}

const ActionArea = ({ leftSection, rightSection, hasSettingBtn = false }: ActionAreaProps) => {
  const [setting, setSetting] = useState(false);
  useEffect(() => {
    const hasSetting = document.querySelector('#colSettingBtn');
    setSetting(!!hasSetting);
  }, []);
  useEffect(() => {
    hasSettingBtn && setSetting(hasSettingBtn);
  }, [hasSettingBtn]);

  return (
    <Box
      direction="row"
      justify="space-between"
      align={'center'}
      className={`${styles.ActionArea} ${setting ? 'actionPadding' : ''} action-bar`}
    >
      {leftSection}
      {rightSection}
    </Box>
  );
};

export default ActionArea;
